import { Icons, OverviewBase, useTypedTranslation } from "@repo/ui";
import helpboxImage from "@repo/ui/assets/images/helpbox.png";
import { type FC } from "react";
import InfoBox, { type AlertProps } from ".";
import { InternalArrowLink } from "../Link/InternalLink";

const HelpBox: FC<AlertProps & { noImage: boolean }> = ({ noImage, ...rest }) => {
    const { t } = useTypedTranslation();
    return (
        <OverviewBase
            sx={{
                backgroundColor: "transparent",
                flexGrow: { md: noImage ? 0 : 1 },
                width: { md: noImage ? "100%" : "57.5%", xs: "100%" },
                "&.MuiCard-root": {
                    alignSelf: "center",
                    px: { md: noImage ? 0 : 4, xs: 0 },
                },
                ".MuiCardMedia-root": {
                    // remove below comment when night run banner is removed
                    // mt: { md: 8 },
                    pb: { md: noImage ? 0 : "174px", xs: 0 },
                    backgroundPosition: "bottom center",
                    backgroundSize: "338px",
                },
            }}
            image={!noImage ? helpboxImage : undefined}
        >
            <InfoBox
                title={t("global.personsOnContract.bannerTitle")}
                action={
                    <InternalArrowLink to="/kontakty/">{t("global.personsOnContract.bannerButton")}</InternalArrowLink>
                }
                icon={<Icons.Question sx={{ width: 32, height: 32 }} color="text" />}
                {...rest}
            >
                Obraťte se na svého poradce nebo na naše operátory. Přesně pro tohle tu jsou.
            </InfoBox>
        </OverviewBase>
    );
};

export default HelpBox;
